import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { HeaderLogo } from '../../Ui/Logo';
const HeaderMaintenance = () => (_jsx("header", Object.assign({ className: 'l-header login-consultant', style: { height: 'auto' } }, { children: _jsx("div", Object.assign({ className: 'l-container', style: { height: '56px' } }, { children: _jsx(HeaderLogo, {}) })) })));
export default HeaderMaintenance;
